
function uploadGCS(url, file) {
  return fetch(url, { // Your POST endpoint
      method: 'PUT',
      //mode: 'no-cors',
      headers: {
        // Content-Type may need to be completely **omitted**
        // or you may need something
        "Content-Type": file.type,
      },
      body: file // This is your file object
    })
    .then(success => Promise.resolve(success)) // Handle the success response object
    .catch(error => {
      console.log(error);
      //throw error;
    }); // Handle the error response object
    
}

export { uploadGCS }